import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=1b5c7f62&"
import script from "./Segment.vue?vue&type=script&lang=ts&"
export * from "./Segment.vue?vue&type=script&lang=ts&"
import style0 from "./Segment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports